import { Goehler_Tool_REST_Client } from '@app/utils/rest-client'
import { handle_api_error } from '@app/utils/api-error'
import ClickEvent = JQuery.ClickEvent
import {GT_Time} from "../../types/times";

export class Project_Status_Controller {
    rest_client: Goehler_Tool_REST_Client

    constructor() {
        this.rest_client = new Goehler_Tool_REST_Client()
    }

    ready() {
        this.init_actions()
    }

    init_actions() {
        jQuery( '[data-action="reset-status"]' ).on( 'click', () => this.reset_status_confirmation() )
        jQuery( 'button[data-approval-status]' ).on( 'click', ( e: ClickEvent ) => this.change_status( e ) )
        jQuery( '[data-action="start-in-progress"]' ).on( 'click', ( e: ClickEvent ) => this.start_in_progress( e ) )
        jQuery( '.project-return[data-editable]' ).on( 'click', () => this.init_update_project_return_modal() )
        jQuery( '.status-times-return[data-editable]' ).on( 'click', () => this.init_update_project_return_modal() )
    }

    /**
     * Öffnet die Bestätigung zum Zurücksetzen des Projekts.
     */
    reset_status_confirmation() {
        const modal = app.get_modal( 'reset-status-confirmation' )

        if ( ! modal ) {
            return
        }

        const textarea = modal.find( '#project-return-reason-reset' )
        const checkbox = modal.find( '#project-return-parts-required-reset-checkbox' )

        textarea.val( project.get_meta_value( 'project-return-reason' ) ?? '' )

        const parts_required = project.has_property( 'return-parts-required' )

        if ( parts_required ) {
            checkbox.checkbox( 'check' )
        } else {
            checkbox.checkbox( 'uncheck' )
        }

        textarea
            .off( 'input.return_reason' )
            .on( 'input.return_reason', () => this.toggle_reset_button( modal ) )

        this.toggle_reset_button( modal )

        modal.modal(
            {
                onApprove: () => {
                    const reason = String( textarea.val() ).trim()

                    if ( reason === '' ) {
                        return false
                    }

                    const parts = checkbox.checkbox( 'is checked' ) as boolean

                    void this.api_reset_status( reason, parts )
                }
            }
        )
        modal.modal( 'show' )
    }

    /**
     * Blockiert den Zurücksetzen-Button, solange kein Grund angegeben ist.
     */
    toggle_reset_button( modal: JQuery ) {
        const empty = String( modal.find( '#project-return-reason-reset' ).val() ?? '' ).trim() === ''

        modal.find( '.positive.button' ).toggleClass( 'disabled', empty )
    }

    /**
     * Setzt das abgeschlossene Projekt als Reklamation in die Montage zurück.
     *
     * @param reason         Grund der Reklamation.
     * @param parts_required Kennzeichnet, ob Bauteile benötigt werden.
     */
    async api_reset_status( reason: string, parts_required: boolean ) {
        console.log( '[REST] reset status' )

        const TASK = 'Zurücksetzen des Projekts'

        jQuery( '.full-screen-loading-dimmer .dimmer' )
            .dimmer( { variation: 'inverted', closable: false } )
            .dimmer( 'show' )

        try {
            const response = await this.rest_client.post(
                'goehler-tool/v1/projects/reset-status',
                {
                    post_id: gt_ajax_object.post_id,
                    reason,
                    parts_required,
                }
            ) as { toast: string, redirect: string }

            if ( response.redirect ) {
                window.location.href = response.redirect
                return
            }

            app.show_toast_ajax_response( response.toast )
        } catch ( error ) {
            jQuery( '.dimmable' ).dimmer( 'hide' )

            handle_api_error( error, TASK )
        }
    }

    /**
     * Startet die Freigabekette für den aktuellen Bereich.
     *
     * Bei der Oberfläche wird zuerst der Lagerplatz abgefragt und gespeichert,
     * damit er auch dann festgehalten ist, wenn die Freigabe abgebrochen wird.
     */
    change_status( e: ClickEvent ) {
        const button = e.currentTarget as HTMLElement

        if ( button.dataset.isAllowed !== '1' ) {
            return
        }

        if ( action_tab === 'finishing' ) {
            project.init_modal_update_storage_yard_assembly()
            return
        }

        void this.api_approve_status_check()
    }

    /**
     * Ermittelt, ob für den Bereich eine Begründung der Zeitüberschreitung
     * erforderlich ist, und öffnet anschließend die Freigabe-Bestätigung.
     */
    async api_approve_status_check() {
        console.log( '[REST] approve status check' )

        const TASK = 'Prüfen der Freigabe'

        const button = document.querySelector( 'button[data-approval-status]' ) as HTMLElement

        if ( ! button ) {
            return
        }

        const data: Record<string, unknown> = {
            post_id: gt_ajax_object.post_id,
            current: String( button.dataset.currentStatus ),
        }

        try {
            const response = await this.rest_client.post(
                'goehler-tool/v1/projects/approve-status-check',
                data
            ) as {
                reason_required: boolean,
                reason?: string,
                status: string
            }

            console.log( `${ TASK }?`, response )

            this.init_modal_approve_status(
                String( button.dataset.currentStatus ),
                String( button.dataset.approvalStatus ),
                response.reason_required,
                response.reason ?? ''
            )
        } catch ( error ) {
            handle_api_error( error, TASK )
        }
    }

    /**
     * Öffnet die Freigabe-Bestätigung und blendet bei Bedarf das
     * Begründungsfeld für die Zeitüberschreitung ein.
     *
     * @param current         Slug des abzuschließenden Bereichs.
     * @param next            Slug des Zielbereichs.
     * @param reason_required Blendet das Begründungsfeld als Pflichtfeld ein.
     * @param reason          Vorhandene Begründung zum Vorbefüllen.
     */
    init_modal_approve_status( current: string, next: string, reason_required: boolean, reason: string ) {
        const modal = app.get_modal( 'approve-status-confirm' )

        if ( ! modal ) {
            return
        }

        const form = modal.find( '#form-approve-status-reason' )
        const textarea = modal.find( '#approve-status-reason' )

        form.prop( 'hidden', ! reason_required )

        textarea.off( 'input.approve_status' )

        if ( reason_required ) {
            textarea.val( reason )
            textarea.on( 'input.approve_status', () => this.toggle_approve_button( modal ) )
        }

        this.toggle_approve_button( modal )

        modal.modal(
            {
                onApprove: () => {
                    if ( reason_required && this.reason_is_empty( modal ) ) {
                        return false
                    }

                    void this.api_approve_status( current, next, reason_required ? String( textarea.val() ).trim() : '' )
                }
            }
        )
        modal.modal( 'show' )
    }

    /**
     * Prüft, ob die Begründungs-Textarea leer ist.
     */
    reason_is_empty( modal: JQuery ): boolean {
        return String( modal.find( '#approve-status-reason' ).val() ?? '' ).trim() === ''
    }

    /**
     * Blockiert den Freigabe-Button, solange eine erforderliche Begründung fehlt.
     */
    toggle_approve_button( modal: JQuery ) {
        const form = modal.find( '#form-approve-status-reason' )

        // Ohne Formular im Modal wird keine Begründung verlangt.
        const required = form.length > 0 && ! form.prop( 'hidden' )

        modal.find( '.positive.button' ).toggleClass( 'disabled', required && this.reason_is_empty( modal ) )
    }

    /**
     * Gibt den Bereich frei und setzt das Projekt in den Folgestatus.
     *
     * @param current Slug des abzuschließenden Bereichs.
     * @param next    Slug des Zielbereichs.
     * @param reason  Begründung der Zeitüberschreitung, leer wenn nicht erforderlich.
     */
    async api_approve_status( current: string, next: string, reason: string ) {
        console.log( '[REST] approve status' )

        const TASK = 'Freigeben des Projekts'

        const dimmer = jQuery( '.full-screen-loading-dimmer .dimmer' )

        dimmer
            .dimmer( { variation: 'inverted', closable: false } )
            .dimmer( 'show' )

        try {
            const response = await this.rest_client.post(
                'goehler-tool/v1/projects/approve-status',
                {
                    post_id: gt_ajax_object.post_id,
                    current,
                    next,
                    reason,
                }
            ) as { toast: string, redirect: string }

            dimmer.removeClass( 'inverted' )
            dimmer.html( '<h2 class="ui inverted active icon header"><i class="checkmark icon"></i>Geschafft!</h2>' )

            app.play_confetti( 'stars' )

            if ( response.redirect ) {
                setTimeout( () => window.location.href = response.redirect, 3000 )
                return
            }

            jQuery( '.dimmable' ).dimmer( 'hide' )

            app.show_toast_ajax_response( response.toast )
        } catch ( error ) {
            jQuery( '.dimmable' ).dimmer( 'hide' )

            handle_api_error( error, TASK )
        }
    }

    /**
     * Speichert die geänderten Reklamations-Angaben über die REST-API.
     */
    async api_update_project_return() {
        console.log( '[REST] update project return' )

        const TASK = 'Speichern der Reklamation'

        const form = jQuery( '#form-project-return-update' )

        const checkbox = form.find( '#project-return-parts-required-update-checkbox' )

        const data: Record<string, unknown> = {
            post_id: gt_ajax_object.post_id,
            reason: String( form.find( '#project-return-reason-update' ).val() ).trim(),
            parts_required: checkbox.checkbox( 'is checked' ) as boolean,
        }

        const button = form.find( '.submit.button' )

        button.addClass( 'loading disabled' ).prop( 'disabled', true )

        try {
            const response = await this.rest_client.post(
                'goehler-tool/v1/projects/update-return',
                data
            ) as {
                toast: string,
                return_reason: string,
                parts_required: boolean,
                properties: []
            }

            console.log( `${ TASK }?`, response )

            app.show_toast_ajax_response( response.toast )

            project.set_meta( 'project-return-reason', response.return_reason )
            project.update_properties_meta( response.properties )

            const container = jQuery( '.project-return' )

            container.find( '.reason .text' ).text( response.return_reason )

            jQuery( '.status-times-return .text' ).text( response.return_reason )

            const parts = container.find( '.parts-required' )

            if ( response.parts_required ) {
                parts.removeAttr( 'data-hidden' )
            } else {
                parts.attr( 'data-hidden', 'true' )
            }

            app.close_modals()
        } catch ( error ) {
            handle_api_error( error, TASK )
        } finally {
            button.removeClass( 'loading disabled' ).prop( 'disabled', false )
        }
    }

    start_in_progress( e: ClickEvent ) {
        const button = e.currentTarget as HTMLElement

        if ( button.classList.contains( 'disabled' ) ) {
            return
        }

        const status = button.dataset.status
        const substatus = button.dataset.substatus

        if ( ! status || ! substatus ) {
            return
        }

        this.init_modal_start_in_progress( status, substatus )
    }

    /**
     * Öffnet die Bestätigung zum Starten der Bearbeitung.
     *
     * @param status     Slug des Bereichs.
     * @param substatus  Slug des aktuellen Substatus.
     */
    init_modal_start_in_progress( status: string, substatus: string ) {
        const modal = app.get_modal( 'start-in-progress-confirmation' )

        if ( ! modal ) {
            return
        }

        // Das Dropdown gibt es nur in der Montage.
        const dropdown = modal.find( '#start-in-progress-workers' )

        if ( dropdown.length ) {
            dropdown.dropdown( 'clear' )
            dropdown.dropdown( 'set selected', gt_current_user.user_id )
        }

        modal.modal(
            {
                onApprove: () => {
                    void this.api_start_in_progress( status, substatus )
                }
            }
        )
        modal.modal( 'show' )
    }

    /**
     * Startet die Bearbeitung des Bereichs und die zugehörigen Arbeitszeiten.
     *
     * @param status     Slug des Bereichs.
     * @param substatus  Slug des aktuellen Substatus.
     */
    async api_start_in_progress( status: string, substatus: string ) {
        console.log( '[REST] start in progress' )

        const TASK = 'Starten der Bearbeitung'

        const button = jQuery( '[data-action="start-in-progress"]' )

        button.addClass( 'loading disabled' )

        const data: Record<string, unknown> = {
            post_id: gt_ajax_object.post_id,
            status,
            substatus,
        }

        const dropdown = jQuery( '#start-in-progress-workers' )

        if ( dropdown.length ) {
            const user_ids = ( dropdown.dropdown( 'get values' ) as string[] ).map( Number )

            if ( user_ids.length ) {
                data.user_ids = user_ids
            }
        }

        try {
            const response = await this.rest_client.post(
                'goehler-tool/v1/projects/start-in-progress',
                data
            ) as {
                toast: string,
                project: Record<string, any>,
                times: GT_Time[]
            }

            console.log( `${ TASK }?`, response )

            app.show_toast_ajax_response( response.toast )

            update_meta_list_item( 'project-substatus', response.project.substatus )
            update_meta_list_item( 'project-status-workers', response.project.status_workers )

            project.update_properties_meta( response.project.properties )
            project.set_times( response.times )
            project.render_approvals()

            void project.times_controller.api_load_times()

            jQuery( '.project-main .dimmable' ).dimmer( 'hide' )
        } catch ( error ) {
            handle_api_error( error, TASK )
        } finally {
            button.removeClass( 'loading disabled' )
        }
    }


    /**
     * Öffnet das Modal zum Bearbeiten der Reklamations-Angaben.
     */
    init_update_project_return_modal() {
        const modal = app.get_modal( 'update-project-return' )

        if ( ! modal ) {
            return
        }

        modal.find( '#project-return-reason-update' ).val(
            project.get_meta_value( 'project-return-reason' ) ?? ''
        )

        const checkbox = modal.find( '#project-return-parts-required-update-checkbox' )

        if ( project.has_property( 'return-parts-required' ) ) {
            checkbox.checkbox( 'check' )
        } else {
            checkbox.checkbox( 'uncheck' )
        }

        modal.modal( 'show' )
    }
}

